var _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgBackArrow(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.01 6.872a.374.374 0 00-.552 0L9.99 12.705a.436.436 0 000 .59l5.47 5.833c.152.163.399.163.552 0a.437.437 0 000-.59L10.818 13l5.193-5.539a.437.437 0 000-.589z",
    fill: "#fff",
    stroke: "#40AFED",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgBackArrow;